<template>
  <page>
    <div slot="headerLeft">
      <el-input
        :placeholder="$t('appList.appName')"
        v-model.trim="params.appName"
        @keyup.enter.native="replaceData"
      />
      <el-button type="primary" plain @click="replaceData">{{ $t('query') }}</el-button>
    </div>
    <div slot="headerRight">
      <c-button
        v-if="btnShow && btnShow.add"
        type="primary"
        round
        icon="iconxinzeng"
        @click="
          currentItem = null
          visible = true
        "
        >{{ $t('appList.uploadApp') }}</c-button
      >
    </div>

    <div class="mainCot" v-loading="loading" v-scroll="loadmore">
      <template v-if="appList.length">
        <el-card class="listItem" v-for="item in appList" :key="item.appId">
          <div class="row viewer" v-viewer>
            <img :src="item.iconPathUrl" />
            <div style="margin-left:20px">
              <h3 class="label">{{ item.appName }}</h3>
              <p class="label">{{ $t('deviceList.versionNo') }}：{{ item.versionName }}</p>
            </div>
          </div>
          <div class="deviceWrap">
            <span class="left">{{ $t('appList.applicableModel') }}：</span>
            <div v-if="item.applicableModel" class="right">
              <span :title="targetObj[child]" v-for="child in item.applicableModel" :key="child">{{
                targetObj[child]
              }}</span>
            </div>
            <div v-else>-</div>
          </div>

          <div class="el-card-bottom">
            <el-button
              v-if="btnShow && btnShow.detail"
              size="small"
              type="primary"
              @click="detailHandler(item)"
              >{{ $t('details') }}</el-button
            >
            <el-button
              v-if="btnShow && btnShow.edit"
              size="small"
              type="primary"
              @click="updateHandler(item)"
              >{{ $t('update') }}</el-button
            >
            <el-button
              v-if="btnShow && btnShow.delete"
              size="small"
              type="danger"
              @click="delHandler(item)"
              >{{ $t('delete') }}</el-button
            >
          </div>
        </el-card>
      </template>
      <p class="no-data" v-else>{{ $t('noData') }}</p>
    </div>

    <add-app-modal
      @getData="replaceData"
      :visible.sync="visible"
      :modelList="modelList"
      :current-item="currentItem"
      v-if="visible"
    />
    <app-detail-modal :app-info="currentItem" :visible.sync="visible2" v-if="visible2" />
  </page>
</template>

<script>
import watchParamsGetData from '@/mixins/watchParamsGetData'
import AddAppModal from './components/AddAppModal'
import AppDetailModal from './components/AppDetailModal'

export default {
  mixins: [watchParamsGetData],
  components: {
    AddAppModal,
    AppDetailModal
  },
  data() {
    return {
      visible: false,
      visible2: false,
      appList: [],
      targetObj: {},
      modelList: [],
      currentItem: null
    }
  },
  created() {
    this.getModelList()
  },
  methods: {
    async getModelList() {
      try {
        const res = await this.$api.deviceManagement.modelList({ pageSize: -1 })
        if (res) {
          const targetArr = []
          const targetObj = {}

          if (res.result && res.result.list) {
            res.result.list.forEach(item => {
              targetArr.push({
                label: item.name,
                value: item.id,
                signatureFileName: item.signatureFileName
              })

              targetObj[item.id] = item.name
            })
          }

          this.modelList = targetArr
          this.targetObj = targetObj
        }
      } catch (e) {
        console.log(e)
      }
    },
    loadmore() {
      if (this.total < this.params.pageSize) {
        return
      }
      ++this.params.currentPage
      this.getData()
    },
    detailHandler(item) {
      this.visible2 = true
      this.currentItem = item
    },
    async delHandler(row) {
      try {
        await this.$confirm(this.$t('appList.deleteApp'), this.$t('tips'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        })
        this.loading = true

        await this.$api.appManagement.appDelete({ appId: row.appId })
        this.$message.success(this.$t('deleteSuccess'))
        this.getData(false)
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
    updateHandler(item) {
      this.visible = true
      this.currentItem = item
    },
    async getData() {
      try {
        if (this.noMore && this.params.currentPage !== 1) return

        this.loading = true
        const res = await this.$api.appManagement.appList(this.params)

        if (res.result) {
          const list = (res.result.list || []).map(item => {
            item.appSize = this.$utils.bytesToSize(item.appSize)
            return item
          })

          let targetList = this.params.currentPage === 1 ? list : this.appList.concat(list)
          this.appList = targetList.map(item => {
            if (item.applicableModel) {
              item.applicableModel = item.applicableModel.split(',').map(Number)
            }

            return item
          })
          if (!list.length && this.params.currentPage !== 1) this.noMore = true
          this.total = res.result.total
        } else {
          this.appList = []
          this.total = 0
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mainCot {
  position: relative;
  min-height: 400px;
  overflow: auto;
  height: 0;
  flex: 1;
  .listItem {
    width: 30%;
    display: inline-block;
    margin-right: 28px;
    margin-bottom: 20px;

    ::v-deep .el-card__body {
      display: flex;
      flex-direction: column;

      div:first-child {
        display: flex;
        margin-bottom: 20px;
        h3 {
          margin-bottom: 10px;
          font-size: 16px;
        }
      }

      img {
        width: 50px;
        height: 50px;
      }
    }
  }
  .deviceWrap {
    display: flex;
    font-weight: bold;
    margin-bottom: 30px;
    .left {
      width: 90px;
      flex-shrink: 0;
    }
    .right {
      max-width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        margin-right: 20px;
        word-break: break-word;
      }
    }
  }
  .el-card-bottom {
    text-align: right;
  }
}
</style>
